import './ssastlouis/style';
import FormStructure from './ssastlouis/form_structure';

export default FormStructure;